import { IMonitorable } from '../monitoring/IMonitorable';
import { TiffBatchJob } from '../job/TiffBatchJob';

export enum TiffBatchStatus {
    Unknown,
    Processing,
    Processed
}

export interface ITiffBatch extends IMonitorable {
    id: string;
    status: TiffBatchStatus;
    projectId: string;
    name: string;
}

export class TiffBatch implements ITiffBatch {
    public id: string;
    public projectId: string;

    public status: TiffBatchStatus;
    public job: TiffBatchJob;

    public name: string;

    constructor(id: string, projectId: string, name: string, percentageComplete: number) {
      this.id = id;
      this.projectId = projectId;
      this.name = name;
      this.job = new TiffBatchJob(percentageComplete);
    }
}
